import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { ErrorAction } from 'store';
import { PaymentDetailsModel } from 'models/Payment';
import { PaymentActionTypes, PaymentActions } from '../';
import { api } from 'repositories/api';
import { userHelper, errorToBasketErrorModel } from 'helpers';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface LoadPaymentAction extends Action<PaymentActionTypes.LOAD_PAYMENT> {
    passedSessionId?: string;
}

export interface LoadPaymentActionStart extends Action<PaymentActionTypes.LOAD_PAYMENT_START> {
}

export interface LoadPaymentActionSuccess extends Action<PaymentActionTypes.LOAD_PAYMENT_SUCCESS> {
    paymentDetails: PaymentDetailsModel;
}

export interface LoadPaymentActionError extends ErrorAction<PaymentActionTypes.LOAD_PAYMENT_ERROR> {
}

export function* loadPaymentSaga({ passedSessionId }: LoadPaymentAction): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.LOAD_PAYMENT_START,
    });

    try {
        let sessionId = passedSessionId || userHelper.getSessionId();
        let username = userHelper.getCurrentUserName();

        let paymentDetails = yield api.hybris.getPaymentDetails(username, sessionId!);

        yield put<PaymentActions>({
            type: PaymentActionTypes.LOAD_PAYMENT_SUCCESS,
            paymentDetails
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.LOAD_PAYMENT_ERROR,
            error: errorToBasketErrorModel(error, 'loadPaymentSaga')
        });

        return false;
    }
}